import { useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface CalloutOptions {
  title?: string;
  description: string;
  variant?: "default" | "destructive" | "success";
}

export const useCallout = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [options, setOptions] = useState<CalloutOptions | null>(null);

  const showNotification = (options: CalloutOptions) => {
    setOptions(options);
    setIsVisible(true);
  };

  const hideNotification = () => {
    setIsVisible(false);
    setOptions(null);
  };

  const CalloutNotification = () => {
    if (!isVisible || !options) return null;

    return (
      <div>
        <Alert 
          variant={options.variant || "default"}
          className="mb-4">
          {options.title && <AlertTitle>{options.title}</AlertTitle>}
          <AlertDescription>{options.description}</AlertDescription>
        </Alert>
      </div>
    );
  };

  return { showNotification, hideNotification, CalloutNotification };
};